import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedShows from './components/FeaturedShows';
import LatestUpdates from './components/LatestUpdates';
import HotShows from './components/HotShows';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '6789影院 - 热门综艺节目免费在线观看高清不缓冲即点即播',
      description: '6789影院收录全网热门综艺节目，免费在线观看高清流畅不缓冲。综艺节目大全每日更新，爆笑综艺、音乐选秀、真人秀全收录。',
      url: 'https://www.6789cinema.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '6789影院',
        url: 'https://www.6789cinema.com/',
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://www.6789cinema.com/',
          },
        ],
      },
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '6789影院的综艺节目都是免费的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的！6789影院所有综艺节目完全免费在线观看，无需注册、无需会员、无需付费。高清画质、流畅不缓冲，随时随地畅享精彩综艺内容。',
          },
        },
        {
          '@type': 'Question',
          name: '综艺节目的更新速度如何？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '6789影院坚持每日更新，紧跟各大平台的播出节奏。热门综艺节目播出后，我们会在最短时间内完成更新。',
          },
        },
        {
          '@type': 'Question',
          name: '观看综艺节目需要安装播放器吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '不需要！6789影院采用先进的在线播放技术，兼容主流浏览器。即点即播，无需安装任何插件或播放器。',
          },
        },
        {
          '@type': 'Question',
          name: '6789影院支持哪些设备观看？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '6789影院全面支持桌面电脑、笔记本电脑、平板电脑和智能手机等多种设备，采用响应式设计，自动适配不同屏幕尺寸。',
          },
        },
        {
          '@type': 'Question',
          name: '如果遇到播放卡顿或缓冲问题怎么办？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '建议检查网络连接、刷新页面、清除浏览器缓存或切换至较低清晰度。如果问题持续存在，欢迎通过关于我们页面联系我们。',
          },
        },
        {
          '@type': 'Question',
          name: '6789影院的综艺节目资源从哪里来？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '6789影院通过合法合规的渠道收录全网优质综艺节目资源，与多家内容平台保持合作关系，严格遵守相关法律法规。',
          },
        },
      ],
    });
    document.head.appendChild(faqScript);
    return () => {
      document.head.removeChild(faqScript);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedShows />
        <LatestUpdates />
        <HotShows />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}